import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW1318Model } from './kymw1318.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { GetDeletePlanGoodsInfoService } from './api-services/get-delete-plan-goods-info';
import { DeletePlanGoodsInfoService } from './api-services/delete-plan-goods-info';
import { GetDeletePlanGoodsInfoModel } from './vo/kymw1318-get-delete-plan-goods-info.model';
import { PlanGoodsModel, DeletePlanGoodsInfoModel } from './vo/kymw1318-delete-plan-goods-info.model';
import { KYMW1318InputModel } from './vo/kymw1318-input.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { FlexGrid, Row } from '@grapecity/wijmo.grid';

/**
 * 受注コード指定選定解除画面を管理するクラス
 *
 * @export KYMW1318Component
 * @class KYMW1318Component
 */
@Component({
  selector: 'app-kymw1318',
  templateUrl: 'kymw1318.component.html',
  styleUrls: ['kymw1318.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1318Component extends PlessViewHelperSub implements OnInit {

  setKYMW1318Parameter: Function;

  kymw1318Model: KYMW1318Model = new KYMW1318Model();
  isEdited = false;

  public editColumns: Array<any> = [''];
  public readonly COLUMN_WIDTH_DEFAULT: number = Number(450);
  public readonly COLUMN_WIDTH_MINIMUN: number = Number(90);
  public colWidth: any = this.COLUMN_WIDTH_MINIMUN;

  /**
   * Creates an instance of KYMW1318Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1318Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
    private getDeletePlanGoodsInfoService: GetDeletePlanGoodsInfoService,
    private deletePlanGoodsInfoService: DeletePlanGoodsInfoService
  ) {
    super(kymw00Model);
  }

  @ViewChild('btn_Set') btn_Set: ElementRef;
  @ViewChild('dtg_targetList') dtg_targetList: FlexGrid;

  /**
   * 初期処理
   *
   * @return {*}  {Promise<any>}
   * @memberof KYMW1318Component
   */
  public async ngOnInit(): Promise<any> {
    this.componentName = 'KYMW1318';

    const vo = new GetDeletePlanGoodsInfoModel();
    vo.orderCode = this.kymw1318Model.orderCode;
    vo.pCode = this.kymw1318Model.pCode;
    vo.mediumType = this.kymw1318Model.mediumType;
    this.getDeletePlanGoodsInfoService.execute(this.kymw1318Model, vo, (data) => {
      // 表示用にデータ整形
      /** ヘッダーに表示する受注コードを格納 */
      for (const e of data.OrderCodeList) {
        if (!this.kymw1318Model.orderCodeList.includes(e)) {
          this.kymw1318Model.orderCodeList.push(e)
        }
      }
      /** セルに表示するチェックボックスの有無と活性制御用のパラメータをdisplayListに格納 */
      const displayList = [];
      for (const e of data.DeletePlanGoodsTargetList) {
        let target = null;
        for (const ee of displayList) {
          if (ee.mediumType === e.MediumType) {
            target = ee;
            break;
          }
        }
        if (target) {
          target.orderCodeList.push(e.OrderCode);
          target.confirmedFlg.push(e.ConfirmedFlg);
        } else {
          target = {
            mediumType: e.MediumType,
            mediumName: e.MediumName,
            orderCodeList: [e.OrderCode],
            confirmedFlg: [e.ConfirmedFlg]
          }
          displayList.push(target)
        }
      }

      this.kymw1318Model.orderCodeList.sort();
      displayList.sort((a, b) => {
        return Number(a.mediumType) - Number(b.mediumType);
      })
      this.kymw1318Model.displayList = displayList;

      // マトリクスにした際に埋まっていない項目（チェックボックスでの設定不可）を埋めていく
      for (const e of this.kymw1318Model.displayList) {
        this.kymw1318Model.displayMap[e.mediumType] = [];
        for (const orderCode of this.kymw1318Model.orderCodeList) {
          // e.orderCodeList内のorderCodeのindexを取得
          let index = e.orderCodeList.indexOf(orderCode);

          if (e.orderCodeList.includes(orderCode)) {
            this.kymw1318Model.displayMap[e.mediumType].push({
              orderCode: orderCode,
              checked: true,
              isDisplayCheckBox: true,
              isDisabledCheckBox: e.confirmedFlg[index] === '1' ? true : false // 企画確定済の場合非活性
            });
          } else {
            this.kymw1318Model.displayMap[e.mediumType].push({
              orderCode: orderCode,
              checked: false,
              isDisplayCheckBox: false,
              isDisabledCheckBox: e.confirmedFlg[index] === '1' ? true : false // 企画確定済の場合非活性
            });
          }
        }
      }

      setTimeout(() => {
        // グリッド設定
        this.initGrid(this.dtg_targetList);
        this.initGridOrderCode(this.dtg_targetList);
      });
    });
  }

  /**
   * グリッド初期化
   * @param {FlexGrid} grid
   * @memberof KYMW4802Component
   */
  private initGrid(grid: FlexGrid): void {
    const extraRow = new Row();
    extraRow.allowMerging = true;
    extraRow.cssClass = 'display-grid';
    const panel = grid.columnHeaders;
    panel.rows.splice(0, 0, extraRow);
    const col = grid.getColumn('mediumName');
    col.allowMerging = true;
    panel.setCellData(0, col.index, col.header);

    // チェックボックスのセルクリックでチェックボックスON/OFF可能とする
    grid.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = grid.hitTest(e);
      if (0 <= ht.row && (!ht.target.className.includes('wj-header') && !ht.target.className.includes('ng-valid'))) {
        if (ht.col > 0) {
          const el = document.getElementById(`OrderCodeSettings_${ht.col}_${ht.row}`);
          if (el) {
            el.click();
          }
        }
      }
    });

    grid.formatItem.addHandler((s, e) => {
      if (e.panel === grid.columnHeaders) {
        if (e.row === 0 && e.col > 0) {
          // 2行のヘッダーの間にボーダーを指定
          e.cell.classList.add('header-split-border');
        }
      }
    })

    // グリッドの列幅調整
    this.editColumns = new Array<any>();
    const list: Array<any> = this.kymw1318Model.orderCodeList;
    for (let j = Number(0); j <list.length; j++) {
      this.editColumns.push(list[j]);
    }
    if (this.editColumns.length === 0) {
      this.editColumns.push('');
    }
    if (this.editColumns.length > 5) {
      this.colWidth = this.COLUMN_WIDTH_MINIMUN;
    } else {
      this.colWidth = this.COLUMN_WIDTH_DEFAULT / this.editColumns.length;
    }
  }

  /**
   * グリッドの受注コードヘッダー初期化
   * @param {FlexGrid} grid
   * @memberof KYMW4802Component
   */
  private initGridOrderCode(grid: FlexGrid) {
    const panel = grid.columnHeaders;
    // 媒体
    const startIndex = 1;
    for (let i = startIndex; i < this.kymw1318Model.orderCodeList.length + startIndex ; i++) {
      panel.setCellData(0, i, '受注コード');
    }
  }

  /**
   * 前画面からのパラメータ設定
   *
   * @param {*}this.inputVo
   * @memberof KYMW1318Component
   */
  public setInterfaceParam(inputVO: KYMW1318InputModel) {
    this.kymw1318Model.orderCode = inputVO.orderCode;
    this.kymw1318Model.pCode = inputVO.pCode;
    this.kymw1318Model.target = inputVO.pCode + ' ' + inputVO.guideGoodsName + '(' + inputVO.guideStandardName + ')';
    this.kymw1318Model.mediumType = inputVO.mediumType;
    this.kymw1318Model.mediumTypeList = inputVO.mediumTypeList;
  }

  /**
   * チェックボックス clickイベント
   *
   * @memberof KYMW1318Component
   */
  public eventCheckbox_CLICKHandler() {
    this.isEdited = true;
  }

  /**
   * 設定ボタン clickイベント
   *
   * @memberof KYMW1318Component
   */
  public clickSettingButton() {
    const vo = new DeletePlanGoodsInfoModel();
    vo.pCode = this.kymw1318Model.pCode;
    vo.planGoodsList = [];
    const checkedList = [];
    for (const key of Object.keys(this.kymw1318Model.displayMap)) {
      for (const e of this.kymw1318Model.displayMap[key]) {
        if (e.isDisplayCheckBox && !e.checked) {
          const val = new PlanGoodsModel();
          val.orderCode = e.orderCode;
          val.mediumType = key;
          vo.planGoodsList.push(val);
        } else if (e.isDisplayCheckBox && e.checked) {
          const val = new PlanGoodsModel();
          val.orderCode = e.orderCode;
          val.mediumType = key;
          checkedList.push(val);
        }
      }
    }

    if (!vo.planGoodsList.length) {
      // エラーメッセージ「選定解除対象の商品企画は1件以上チェックを外してください。」
      this.dialogService.openAlertGetMessage('W0063');
      return;
    }

    if (checkedList.length > 0) {
      const filterMediumTypeList = checkedList.filter((item) => item.orderCode === this.kymw1318Model.orderCode);
      const resultList = filterMediumTypeList.map((result) => 
        this.kymw1318Model.mediumTypeList.find(m => m.MediumType === result.mediumType)
      );

      // 選定解除を行わない中にクーポン媒体、ポイント交換媒体が存在するか確認
      const isCoupon = resultList.some((item) => item.MediumGroupDiv === '03');
      const isPointExchange = resultList.some((item) => item.MediumGroupDiv === '04');

      if (isCoupon && isPointExchange ) {
        // 通常媒体のものが無い場合エラー
        const result = resultList.some((item) => item.MediumGroupDiv === '01');
        if (!result) {
          this.dialogService.openAlertGetMessage('E0652', [vo.pCode, vo.pCode]);
          return;
        }
      } else if (isCoupon) {
        // 通常媒体、1物N価媒体、予約媒体のものが無い場合エラー
        const result = resultList.some((item) =>
          item.MediumGroupDiv === '01'
          || item.MediumGroupDiv === '02'
          || item.MediumGroupDiv === '05'
        );
        if (!result) {
          this.dialogService.openAlertGetMessage('E0650', [vo.pCode]);
          return;
        }
      } else if (isPointExchange) {
        // 通常媒体のものが無い場合エラー
        const result = resultList.some((item) => item.MediumGroupDiv === '01');
        if (!result) {
          this.dialogService.openAlertGetMessage('E0651', [vo.pCode]);
          return;
        }
      }
    }

    this.deletePlanGoodsInfoService.execute(this.kymw1318Model, vo, () => {
      this.dialogService.openAlertGetMessage('I0513', [], e => {
        if (e === PlessAlert.Yes) {
          super.onClickClose();
        }
      });
    });
  }

  /**
   * モーダル閉じる場合 ダイアログ表示
   *
   * @param data
   * @memberof KYMW4602Component
   */
  public onClickClose(): void {
    if (this.isEdited) {
      this.dialogService.openAlertGetMessage('Q0110', [], e => {
        if (e === PlessAlert.Yes) {
          super.onClickClose();
        }
      });
    } else {
      super.onClickClose();
    }
  }
}
